import { DynamicOfferingApiClient } from '../ApiClients/ProtoServicesApiClients';
import { createApiQuery } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DomainsServerlessApiConfig } from '../../apiConfigurations/DomainsServerlessApiConfig';
import { extractTld, parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
const DomainsTldsApi = createApiQuery({
  methodConfig: DomainsServerlessApiConfig.domainTlds
});
export const getRedeemOrderPageData = async _ref => {
  var _tlds$filter;
  let {
    httpClient,
    request
  } = _ref;
  const {
    domainsLogger
  } = await dynamicLoadApiQueries(httpClient);
  const {
    domain
  } = request;
  const parsedDomain = parseDomain(domain);
  const domainTld = extractTld(domain);
  if (!domain || parsedDomain.error) {
    domainsLogger({
      error: new Error(`Bad domain name: ${domain}: ${parsedDomain.error}`),
      type: 'error',
      entity: 'domainRedemption',
      message: `Bad domain name: ${domain}: ${parsedDomain.error}`
    });
    throw new Error(`Bad domain name: ${domain}: ${parsedDomain.error}`);
  }
  const {
    tlds
  } = await DomainsTldsApi({
    httpClient,
    request: {
      disableGeoFiltering: true
    }
  });
  const redemptionProductId = (_tlds$filter = tlds.filter(tld => tld.tld === domainTld)) == null || (_tlds$filter = _tlds$filter[0]) == null ? void 0 : _tlds$filter.redemptionFeeDynamicProductId;
  const {
    riskIframeUrl,
    ...rest
  } = await DynamicOfferingApiClient.query.createOrderPage({
    httpClient,
    request: {
      cartItems: [{
        additionalData: {
          domainName: domain
        },
        productId: redemptionProductId ?? undefined,
        cycle: {
          oneTime: {}
        },
        quantity: 1,
        newSubscription: {}
      }]
    }
  });
  return {
    ...rest,
    riskCheckIframeUrl: riskIframeUrl,
    // TODO: email param is basically deprecated, should be removed once types will be updated on checkout-components.
    userEmail: ''
  };
};
//# sourceMappingURL=domainRedemptionAggregations.js.map